import { Component, Input } from '@angular/core';

@Component({
  selector: 'icon-clock',
  imports: [],
  templateUrl: './icon-clock.component.html',
  styles: ''
})
export class IconClockComponent {
  @Input() size: number = 24;
}
